module.exports = __webpack_public_path__ + "static/media/logo-color-en.85a879c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-color-en.svg
// module id = 154
// module chunks = 0